import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Push } from 'app/shared/models/class/notification/notification';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getPush(): Observable<Push[]> {
    return this.http.get<Push[]>(`${environment.apiUrl}notifications`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  addNotificationProg(push: Push) {
    return this.http.post(`${environment.apiUrl}/notifications`, push);
  }

  addNotificationNow(push: Push) {
    return this.http.post(`${environment.apiUrl}/notifications/now`, push);
  }

  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

  deleteNotification(id: string) {
    return this.http.delete(`${environment.apiUrl}/notifications/${id}`);
  }
}
